import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

import { FRAGMENT_PROJECT_LONG_FORM_SECTION } from './schema';

const QUERY = gql`
  query LongFormDraftSections($projectId: Int!, $draftIndex: ID) {
    project(id: $projectId) {
      longFormBuilderOutlineSections(longFormBuilderDraftId: $draftIndex) {
        ...LongFormSection
      }
    }
  }
  ${FRAGMENT_PROJECT_LONG_FORM_SECTION}
`;

export const queryLongFormDraftSections = async ({ projectId, draftIndex }, options = null) => {
  const variables = {
    projectId,
    draftIndex,
  };

  const response = await executeGqlQuery({
    query: QUERY,
    variables,
    options: {
      abortSignal: options?.abortSignal,
    },
  });
  const data = getSingleProp(response.data);
  return data?.longFormBuilderOutlineSections || [];
};
